import React from "react";
import { SvgProps } from "../../types";

// "#F6142D" - red "#FF9D00" - yellow

export const NotifyBellIcon = (props: SvgProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width}
      height={props.height}
      viewBox="0 0 18 20"
      className={props.classNames?.join(" ") || ""}
    >
      <path
        d="M7.92478 4.00924L7.52603 1.87891M7.92478 4.00924C9.18188 3.8236 10.4619 4.13429 11.494 4.87558C12.5262 5.61687 13.2294 6.7306 13.455 7.98116L13.7584 9.60274C14.1618 11.7523 15.9429 11.9751 16.1418 13.0503C16.2426 13.5875 16.3434 14.1237 15.8576 14.2154L4.21594 16.3943C3.73103 16.4851 3.63019 15.947 3.52936 15.4098C3.32861 14.3355 4.90986 13.483 4.50836 11.3334C4.30761 10.2618 4.70819 12.3986 4.20586 9.71182C3.9641 8.46435 4.21709 7.17175 4.91132 6.10747C5.60556 5.0432 6.68658 4.29073 7.92569 4.00924H7.92478ZM1.46594 8.05174C1.59703 6.33116 2.21944 4.87916 3.37811 3.60041M5.80361 16.0973C6.04272 16.7786 6.50636 17.3583 7.11842 17.7413C7.73048 18.1243 8.45457 18.2878 9.17181 18.205C9.88905 18.1221 10.5568 17.7979 11.0655 17.2855C11.5741 16.773 11.8934 16.1029 11.9709 15.3851L12.0534 14.9267L5.80361 16.0973Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
